import {
  ADMIN_USER_TYPE,
  ADMIN_VIEW_USER_TYPE,
  CONFIG_ADMIN_USER_TYPE, CONFIG_ADMIN_VIEW_USER_TYPE,
  MEMBER_USER_TYPE, MEMBER_VIEW_USER_TYPE, TEMPLATE_PAGE_DASHBOARD,
} from 'consts';
import PageComponent from 'pages';

const Dashboard = () => PageComponent({
  translationLabel: 'dashboard',
  template: TEMPLATE_PAGE_DASHBOARD,
  queryFunction: async ({
    api, filters, pagination, granularity, userType, setTimeToRefetch,
  }) => {
    const data = await api.energyCommunities.getRevenueByEcid({
      startRange: filters?.startRange,
      endRange: filters?.endRange,
      configId: filters?.configurationFilter,
      ecId: filters?.energyCommunityFilter,
      participantLaId: filters?.podFilter,
      pageNumber: pagination.pageNum,
      resultPerPage: pagination.pageSize,
    }, granularity);

    setTimeToRefetch(data.nextUpdate ?? 0);
    let toRet = {};
    if (userType === ADMIN_USER_TYPE || userType === ADMIN_VIEW_USER_TYPE) {
      toRet = {
        members: data?.cerTotalMembers,
        shared: data?.cerTotalSharedEnergy,
        rewards: data?.cerTotalRevenue,
        saturation: data?.cerSaturation,
        health: data?.cerHealth,
        totalConfig: data?.cerTotalConfigurations,
        totalPower: data?.cerTotalPower,
        savedCO2: data?.cerSavedCO2,
        generation: data?.cerTotalGeneration,
        consumption: data?.cerTotalConsumption,
        lastMeasuredUpdate: data?.lastMeasuredUpdate,
        lastEstimatedUpdate: data?.lastEstimatedUpdate,
        lastFiscalUpdate: data?.lastFiscalUpdate,
        revenueData: data?.cerRevenue,
        energyReportData: data?.cerEnergyReport,
      };
    }
    if (userType === CONFIG_ADMIN_USER_TYPE || userType === CONFIG_ADMIN_VIEW_USER_TYPE) {
      toRet = {
        members: data?.configTotalMembers,
        shared: data?.configTotalSharedEnergy,
        rewards: data?.configTotalRevenue,
        saturation: data?.configSaturation,
        health: data?.configHealth,
        totalPlants: data?.configTotalPlants,
        totalPower: data?.configTotalPower,
        savedCO2: data?.configSavedCO2,
        generation: data?.configTotalGeneration,
        consumption: data?.configTotalConsumption,
        lastMeasuredUpdate: data?.lastMeasuredUpdate,
        lastEstimatedUpdate: data?.lastEstimatedUpdate,
        lastFiscalUpdate: data?.lastFiscalUpdate,
        revenueData: data?.configRevenue,
        energyReportData: data?.configEnergyReport,
      };
    }
    if (userType === MEMBER_USER_TYPE || userType === MEMBER_VIEW_USER_TYPE) {
      toRet = {
        configConsumption: data?.configTotalConsumption,
        configShared: data?.configTotalSharedEnergy,
        configGeneration: data?.configTotalGeneration,
        memberConsumption: data?.memberTotalConsumption,
        memberShared: data?.memberTotalSharedEnergy,
        memberGeneration: data?.memberTotalGeneration,
        rewards: data?.memberTotalRevenue,
        saturation: data?.configSaturation,
        savedCO2: data?.memberSavedCO2,
        contemporaneity: data?.memberContemporaneityFactor,
        lastMeasuredUpdate: data?.lastMeasuredUpdate,
        lastEstimatedUpdate: data?.lastEstimatedUpdate,
        lastFiscalUpdate: data?.lastFiscalUpdate,
        energyPerformanceData: {
          memberContemporaneityFactor: data?.memberContemporaneityFactor,
          clusterContemporaneityFactor: data?.clusterContemporaneityFactor,
          solarHappiness: data?.solarHappiness,
        },
        revenueData: data?.memberRevenue,
        energyReportData: data?.configEnergyReport,
      };
    }
    return toRet;
  },
});

export default Dashboard;
